import { showError, clearErrors } from '../../portal-shared';

const form = document.querySelector('.js-login-form')!;
const emailInput = document.getElementById('email')!;
const passwordInput = document.getElementById('password')!;

form.addEventListener('submit', (e) => {
    clearErrors();
    const email = ((emailInput as HTMLInputElement).value || '').trim();
    const password = (passwordInput as HTMLInputElement).value || '';
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!email) {
        e.preventDefault();
        showError('Email cannot be blank.');
        emailInput.focus();
        return;
    }
    if (!emailRegex.test(email)) {
        e.preventDefault();
        showError('Please enter a valid email address.');
        emailInput.focus();
        return;
    }
    if (!password) {
        e.preventDefault();
        showError('Password cannot be blank.');
        passwordInput.focus();
        return;
    }
});

if (module.hot) { module.hot.accept(); }
